import { TGpsrProductType } from 'redux/reducers/gpsr/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
	TTableStructureButton,
} from 'ui/EasTable/types';
import { EIconButtons } from '../../../ui/EasTable/EasTableRow/EasTableValue/constants';

export const gpsrProductTypeTableStructure: TTableStructure<keyof TGpsrProductType>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof TGpsrProductType,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Created At',
		selector: 'createdAt' as keyof TGpsrProductType,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},

	{
		name: 'Product Type Name',
		selector: 'name' as keyof TGpsrProductType,
		show: true,
		searchable: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Description',
		selector: 'description' as keyof TGpsrProductType,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'SKUs Count',
		selector: 'skusCount' as keyof TGpsrProductType,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Marked for removal',
		selector: 'removeOnRenewal' as keyof TGpsrProductType,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		name: 'Author',
		selector: 'author' as keyof TGpsrProductType,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'delete' as keyof TGpsrProductType,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		buttons: [
			{ name: 'Tech File' },
			{ name: 'DoC File' },
			{ name: 'Mark for Removal' },
			{ name: 'Edit', icon: EIconButtons.EDIT },
			{ name: 'Delete', color: 'error.main', icon: EIconButtons.DELETE },
		],
		buttonFilter: (item: TGpsrProductType) => {
			const buttons = [] as TTableStructureButton[];
			buttons.push({ name: 'Tech File' }, { name: 'DoC File' });
			if (!item.removeOnRenewal) {
				buttons.push({ name: 'Mark for Removal' });
			}
			buttons.push(
				{ name: 'Edit', icon: EIconButtons.EDIT },
				{ name: 'Delete', color: 'error.main', icon: EIconButtons.DELETE },
			);
			return buttons;
		},
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
];
